// extracted by mini-css-extract-plugin
module.exports = {"image":"ImageUpload_image__2YtUO","uploadText":"ImageUpload_uploadText__3_xzS","removeButton":"ImageUpload_removeButton__3I6OT"};